import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-distribution-preproject-file',
  templateUrl: './distribution-preproject-file.component.html',
  styleUrls: ['./distribution-preproject-file.component.scss']
})
export class DistributionPreprojectFileComponent implements OnInit {

  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  strategy : any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private main : MainService,
    private fb : FormBuilder,
    private dialogRef: MatDialogRef<DistributionPreprojectFileComponent>,
  ) {
    this.strategy = this.data.strategy;
   }

  ngOnInit(): void {
    console.log(this.strategy);
    this.preloadFormData();
    this.loadForm();
  }

  preloadFormData(){
    this.bodyForm.append('folder_str', this.strategy.folder as string);
    this.bodyForm.append('id_str', this.strategy.id);
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}]
    });
  }

  saveDistributionOdt() {
    Swal.fire({
      title: 'Con estos cambios el VoBo previo cambiará a "Pendiente"',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {
      if (result.isConfirmed) {
        if(this.form.value.blob != null && this.form.value.blob?.length!=0){
          this.bodyForm.append("blob", this.form.value.blob[0] as File);
          Swal.fire({
            icon: 'info',
            title: 'Subiendo archivo...',
            text:'Esto puede tardar algunos minutos, favor de no cerrar o recargar la pagina.',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          this.campaignService.uploadOdtFile(this.bodyForm).subscribe(
            (result:any)=>{
              if(result.message == 'Success'){
                Swal.fire({
                  icon: 'success',
                  title: 'Archivo subido',
                  text: 'Archivo subido exitosamente'          
                }).then(() => {            
                  this.dialogRef.close({ reload: true });
                });
                console.log("upload data", result);
              }
              else {                
                Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
              });
            }
            },
            (err:any)=>{
              this.main.HideLoading();
              if(err.error.message == "Invalid file") {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error',
                  html: 'Solo se permiten documentos en formato .zip'
                });
              }
              else if(err.error.message == "Incorrect data") {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error',
                  html: 'Los datos de los materiales (' + err.error.data.toString() + ') son incorrectos.'
                });
              }
              else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
                });
              }
            }
          )
        }
        else {
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            html: 'El documento no ha sido adjuntado'
          });
        }
      }
    });
  }

  onValueChange(files : any)
  { 
    if(files.length >= 2)
    {      
      files.splice(1, 1);
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Sólo puede adjuntarse un documento'
      });
    }

    for (const item of files) {
      if(!(item.name.endsWith('.zip')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .ZIP'
        });
    
        if (index >= 0) {
          files.splice(index, 1);
        }
      }
    }
  }

}
